<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm-tit">T<span class="small">ABLE OF</span> C<span class="small">ONTENTS</span></h2>
<p class="toc"><a href="#/xhtml/fm02"><i>Acknowledgments</i></a></p>
<p class="toc"><a href="#/xhtml/fm03"><i>Foreword</i></a></p>
<p class="toc"><a href="#/xhtml/fm04"><i>Introduction</i></a></p>
<p class="tocca"><span href="#/xhtml/chap01" title="Link target outside of Sample"><span class="tno">Chapter 1</span> A Divine Design</span></p>
<p class="tocc"><span href="#/xhtml/chap02" title="Link target outside of Sample"><span class="tno">Chapter 2</span> A Polished Arrow</span></p>
<p class="tocc"><span href="#/xhtml/chap03" title="Link target outside of Sample"><span class="tno">Chapter 3</span> A Vocational Vantage Point</span></p>
<p class="tocc"><span href="#/xhtml/chap04" title="Link target outside of Sample"><span class="tno">Chapter 4</span> Vocational Fields of Service</span></p>
<p class="tocc"><span href="#/xhtml/chap05" title="Link target outside of Sample"><span class="tno">Chapter 5</span> Wisdom to Work With</span></p>
<p class="tocc"><span href="#/xhtml/chap06" title="Link target outside of Sample"><span class="tno">Chapter 6</span> The Disciple Maker’s Aim &amp; Ingredients</span></p>
<p class="tocc"><span href="#/xhtml/chap07" title="Link target outside of Sample"><span class="tno">Chapter 7</span> The Disciple Maker’s Process of Transformation</span></p>
<p class="tocc"><span href="#/xhtml/chap08" title="Link target outside of Sample"><span class="tno">Chapter 8</span> The Disciple Maker’s Tools</span></p>
<p class="tocc"><span href="#/xhtml/chap09" title="Link target outside of Sample"><span class="tno">Chapter 9</span> More Vocational Disciple Making Stories</span></p>
<p class="toccb"><span href="#/xhtml/chap10" title="Link target outside of Sample"><span class="tno">Chapter 10</span> Beginning with the End in Mind</span></p>
<p class="toc"><span href="#/xhtml/bm01" title="Link target outside of Sample"><i>About the Author</i></span></p>
<p class="toc"><span href="#/xhtml/bm02" title="Link target outside of Sample"><i>Endnotes</i></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// content.vue?986733dc